import "./style.scss";

import {FC} from "react";
import { motion } from "framer-motion";

interface badDescriptions {
    code: string,
    name: string,
    description: string
}

interface NotificationsListProps {
    badReasons?: badDescriptions[],
    goodReasons?: badDescriptions[],
}

const TrustfullReasonList: FC<NotificationsListProps> = ({
                                                             goodReasons,
                                                             badReasons
                                                         }) => {

    const reasonVariants = {
        hidden: { opacity: 0, scale: 0.9 },
        visible: { opacity: 1, scale: 1 },
    };

    return (
        <div className="reason-container mb-1">
            {goodReasons && goodReasons.length > 0 && (
                <motion.div
                    className="reason-card good"
                    initial="hidden"
                    animate="visible"
                    variants={reasonVariants}
                    transition={{ duration: 0.4 }}
                >
                    <div className="reason-title tag tag-info">Cohérents</div>
                    <ul className="reason-list">
                        {goodReasons.map((reason, i) => (
                            <motion.li
                                key={i}
                                initial="hidden"
                                animate="visible"
                                variants={reasonVariants}
                                transition={{ duration: 0.4, delay: 0.1 * i }}
                            >
                                <span className="reason-number">{i + 1}.</span> {reason.description}
                            </motion.li>
                        ))}
                    </ul>
                </motion.div>
            )}

            {badReasons && badReasons.length > 0 && (
                <motion.div
                    className="reason-card bad"
                    initial="hidden"
                    animate="visible"
                    variants={reasonVariants}
                    transition={{ duration: 0.4, delay: 0.1 }}
                >
                    <div className="reason-title tag tag-error">Incohérents</div>
                    <ul className="reason-list">
                        {badReasons.map((reason, i) => (
                            <motion.li
                                key={i}
                                initial="hidden"
                                animate="visible"
                                variants={reasonVariants}
                                transition={{ duration: 0.4, delay: 0.1 * i }}
                            >
                                <span className="reason-number">{i + 1}.</span> {reason.description}
                            </motion.li>
                        ))}
                    </ul>
                </motion.div>
            )}
        </div>
    );
};

export default TrustfullReasonList;
